export enum APP_STATUS {
  INIT = 'INIT',
  LOADING = 'LOADING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}
